/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      helper — `(tenant-css-split css)`: `{ imports, rest }` of the
 *              tenant free CSS (open_advanced option1), pure
 *   extends:   none (function helper)
 *   template:  none
 *   uses:      lib/tenant-css-split (splitTenantCss)
 *   siblings:  components/ec-tenant-css-imports (prints `imports`)
 *   tests:     tenant-css-split-test.js
 *   gotchas:   the application controller is a frozen god file (size ratchet):
 *              the split lives here instead of a controller getter.
 */
import { helper } from '@ember/component/helper';
import { splitTenantCss } from '../lib/tenant-css-split';

export default helper(([css]) => splitTenantCss(css));
